<template>
  <div>
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择所属业务"
      :data="data"
      :clickAddButton="clickAddButton"
    ></top-bar>
    <base-table
      :tableData="tableData"
      v-if="tableData.tableList"
      @handleClick="handleClick"
    ></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <!-- 新增 -->
    <base-dialog
      :dialogShow="dialogShow"
      @dialogHandel="dialogHandel"
      @closeDialog="closeDialog"
      :formData="formData"
    ></base-dialog>
    <!-- 编辑 -->
    <base-dialog
      :dialogShow="editDialogShow"
      @dialogHandel="editDialogHandel"
      @closeDialog="editCloseDialog"
      :formData="formData"
    ></base-dialog>
    <!-- 删除 -->
    <modal
      :isShow.sync="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
      @update:isShow="handleDialogLabel(false)"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
  </div>
</template>

<script>
import topBar from "../../../../components/topBar";
import baseTable from "../../../../components/baseTable";
import breadCrumb from "../../../../components/breadCrumb";
import baseDialog from "../../components/baseDialog";
import pagination from "../../../../components/pagination";
import {
  pageContentBusiness,
  saveOrUpdateContentBusiness,
  deleteContentBusiness,
} from "@/api/man";
import modal from "@/components/modal";

export default {
  name: "businessManage",
  data() {
    return {
      isShowSelect: false,
      data: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      dialogShow: false,
      editDialogShow: false,
      formData: {
        formList: {
          title: "新增业务",
          nameKey: "业务名称",
          contentDisclosure: "内容是否公开",
          showShare: 0,
          showShareDesc: "限制分享字段",
          publicity: "1",
          nameValue: "",
          infoKey: "备注",
          infoValue: "",
          placeholder: "请输入申请理由",
          maxlength: "150",
          type: 0, //0(13\16) or 1(28)
          isShow: true,
        },
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "业务ID",
            prop: "id",
          },
          {
            label: "业务名称",
            prop: "name",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
        ],
        tableType: 5,
      },
      btnText: ["取消", "确认"],
      isShowBtn: [true, true, false],
      deleteDialog: false,
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      editValue: null,
      deleteValue: null,
    };
  },
  components: {
    baseTable,
    topBar,
    breadCrumb,
    baseDialog,
    pagination,
    modal,
  },
  watch: {
    "formData.formList.nameValue"(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.formList.nameValue = this.$utils.removalSpace(newValue);
      }
    },
  },
  created() {
    this.pageContentBusiness();
  },
  methods: {
    resetFormList() {
      console.log("reset");
      this.formData.formList.title = "新增业务";
      this.formData.formList.nameKey = "业务名称";
      this.formData.formList.contentDisclosure = "内容是否公开";
      this.formData.formList.showShare = 0;
      this.formData.formList.showShareDesc = "限制分享字段";
      this.formData.formList.publicity = "1";
      this.formData.formList.nameValue = "";
      this.formData.formList.infoKey = "备注";
      this.formData.formList.infoValue = "";
      this.formData.formList.placeholder = "请输入申请理由";
      this.formData.formList.maxlength = "150";
      this.formData.formList.type = 0;
      this.formData.formList.isShow = true;
    },
    async pageContentBusiness() {
      console.log("刷新列表");
      let res = await pageContentBusiness({
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      })
        .then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            this.tableData.tableList.push(item);
            this.paginationDataProduct.total = res.totalCount;
            this.paginationDataProduct.currentPage = res.pageNo;
            this.paginationDataProduct.pageSize = res.pageSize;
          });
        })
        .catch((error) => {});
    },
    // 新增
    clickAddButton() {
      this.resetFormList();
      this.dialogShow = true;
    },
    dialogHandel(data) {
      this.dialogShow = data;
      if (!data) {
        // this.resetFormList()
      }
    },
    editDialogHandel(data) {
      this.editDialogShow = data;
      if (!data) {
        // this.resetFormList()
      }
    },
    showDialog() {
      this.dialogShow = true;
    },
    closeDialog(data) {
      if (data === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != ""
        ) {
          saveOrUpdateContentBusiness({
            tenantId: this.$commonJs.getTenantId(),
            id: null,
            name: this.formData.formList.nameValue,
            introduction: this.formData.formList.infoValue,
            rangeType: this.formData.formList.publicity,
            showShare: this.formData.formList.showShare,
          })
            .then((res) => {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.dialogShow = false;
              this.pageContentBusiness();
            })
            .catch((res) => {
              console.log(res);
              if (res.data === 0) {
                this.$message.error(res.msg);
              } else if (res.data === -1) {
                this.$message.error(res.msg);
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          this.$message.error("请输入业务名称");
        }
      } else if (data === "cancel") {
        this.dialogShow = false;
      }
    },
    editCloseDialog(target) {
      console.log(target, "editCloseDialogeditCloseDialogeditCloseDialog");
      if (target === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != ""
        ) {
          saveOrUpdateContentBusiness({
            tenantId: this.$commonJs.getTenantId(),
            id: this.editValue.id,
            name: this.formData.formList.nameValue,
            introduction: this.formData.formList.infoValue,
            rangeType: this.formData.formList.publicity,
            showShare: this.formData.formList.showShare || 0,
          })
            .then((res) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.editDialogShow = false;
              this.pageContentBusiness();
            })
            .catch((res) => {
              this.$message.error(res.msg);
            });
        } else {
          this.$message.error("请输入业务名称");
        }
      } else if (target === "cancel") {
        this.editDialogShow = false;
      }
    },
    handleClick(val) {
      if (val.type == "edit") {
        this.editDialogShow = true;
        this.formData.formList.title = "修改业务";
        this.getEditVal(val.val);
        this.formData.formList.nameValue = this.editValue.name;
        this.formData.formList.infoValue = this.editValue.introduction;
        this.formData.formList.publicity = this.editValue.rangeType.toString();
        this.formData.formList.showShare = this.editValue.showShare;
        console.log(this.formData.formList, "this.formData.formList");
      } else if (val.type == "delete") {
        this.deleteDialog = true;
        this.getDeleteVal(val.val);
      }
    },
    handleDialogLabel(val) {
      this.deleteDialog = val;
    },
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteDialog = false;
      } else if (val === "two") {
        deleteContentBusiness({
          tenantId: this.$commonJs.getTenantId(),
          id: this.deleteValue.id,
        })
          .then((res) => {
            this.deleteDialog = false;
            if (res) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.pageContentBusiness();
            }
          })
          .catch((error) => {
            this.$message.error(error.msg);
          });
      }
    },
    getEditVal(val) {
      console.log("getEditVal", val);
      this.editValue = val;
    },
    getDeleteVal(val) {
      this.deleteValue = val;
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageContentBusiness();
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-textarea__inner) {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
  display: inline-block;
  margin-bottom: 45px;
  margin-right: 15px;
  /*padding: 0 0;*/
  /*min-height: 23px;*/
}

:deep(.el-dialog__body) {
  padding: 30px 26px 0px 26px !important;
}
</style>
